import { makeStyles, withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import DOMPurify from 'dompurify'

import LabelWrapper from '../LabelWrapper'

const styles = theme => ({
  labelwrap: {
    '&.regular-form': {
      borderBottom: theme.borders.default,
      '& $htmlwrap': {
        margin: `${theme.spacing(2)} 0`,
        border: 'none',
        backgroundColor: theme.inputField.inputBGColorActive,
      },
    },
  },
  htmlwrap: {
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    border: theme.borders.default,
    borderRadius: 4,
    marginBottom: 12,
    '&.not-full': {
      display: 'inline-block',
    },
  },
})

const HTMLWrapper = ({ classes, content, fullWidth, withBorder, htmlStyle, ...rest }) => {
  let customClasses = {}
  if (htmlStyle) {
    const useStyles = makeStyles({
      customStyle: {
        ...htmlStyle,
      },
    })
    // biome-ignore lint/correctness/useHookAtTopLevel: TODO
    customClasses = useStyles()
  }

  const html = (
    <div
      className={cn(classes.htmlwrap, customClasses.customStyle, {
        'not-full': !fullWidth,
      })}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: TODO
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content),
      }}
    />
  )
  return (
    <LabelWrapper
      className={cn(classes.labelwrap, {
        'regular-form': !withBorder,
      })}
      {...rest}
    >
      {html}
    </LabelWrapper>
  )
}

HTMLWrapper.defaultProps = {
  fullWidth: true,
  withBorder: false,
}

const HTMLWrapperComponent = withStyles(styles)(HTMLWrapper)
HTMLWrapperComponent.displayName = 'HTMLWrapper'
export default HTMLWrapperComponent
